var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-padded"},[_c('AxButton',{attrs:{"disabled":_vm.isLoading,"loading":_vm.isLoading},on:{"click":_vm.calculate}},[_vm._v(" "+_vm._s(_vm.$t('calculate'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }